/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgInstructorTrainingPlus = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 15c5.306 0 7 2.917 7 7h-2c0-2.861-.708-5-5-5s-5 2.139-5 5H5c0-4.083 1.694-7 7-7zm0-9a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm10 4v4h-4v-2h2v-2zm-8-8v2H4v8h2v2H2V2zm-2 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm8-6v2h2v2h-2v2h-2V6h-2V4h2V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgInstructorTrainingPlus as InstructorTrainingPlus };
